/**
 * Statik görseller için WebP + JPEG fallback üretir.
 * Orijinal yol (.png / .jpg) korunur; tarayıcı desteklediğinde .webp sunulur.
 */
export function getOptimizedSources(src) {
  if (!src) {
    return { webp: null, fallback: src };
  }

  if (/^https?:\/\//i.test(src) || src.includes('/uploads/') || src.endsWith('.webp')) {
    return { webp: null, fallback: src };
  }

  const match = src.match(/^(.+)\.(png|jpe?g)$/i);
  if (!match) {
    return { webp: null, fallback: src };
  }

  return {
    webp: `${match[1]}.webp`,
    fallback: `${match[1]}.jpg`,
  };
}

export default function OptimizedImage({
  src,
  alt = '',
  className,
  loading,
  decoding,
  fetchPriority,
  width,
  height,
  onError,
  ...rest
}) {
  const { webp, fallback } = getOptimizedSources(src);
  const imgProps = {
    alt,
    className,
    loading,
    decoding,
    fetchPriority,
    width,
    height,
    onError,
    ...rest,
  };

  if (!fallback) {
    return null;
  }

  if (!webp) {
    return <img src={fallback} {...imgProps} />;
  }

  return (
    <picture>
      <source srcSet={webp} type="image/webp" />
      <img src={fallback} {...imgProps} />
    </picture>
  );
}
